/* eslint-disable no-unused-expressions */
import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import '../style.scss';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Menu, Spin, Table, notification, Popconfirm, Button } from 'antd';
import { CloseOutlined, PlusCircleFilled, SaveOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import WorkflowActions from '@Actions/workflowActions';
import SelectRole from '@Components/Common/SelectRole';
import DepartmentActions from '@Actions/departmentActions';
import './style.scss';
import Helpers from '@Apis/helpers';
import UserActions from '@Actions/userActions';
import { GetAnnualMaintenanceContractWorkflows } from '../../../../modules/workFlowAMC';
import { GetPurchaseIndentWorkflows } from '../../../../modules/purchase/purchaseIndent';
import { GetAPInvoiceWorkflows } from '../../../../modules/purchase/accountPayableInvoice';

const WorkflowList = ({
  onlyStore, getRoles, roles,
  getPurchaseRequestWorkflows, getPurchaseRequestWorkflowsLoading,
  getPurchaseIndentWorkflows, getPurchaseIndentWorkflowsLoading,
  getInvoiceWorkflows, getInvoiceWorkflowsLoading,
  getPurchaseWorkflows, getPurchaseWorkflowsLoading,
  getSalesOrderWorkflows, getSalesOrderWorkflowsLoading,
  getPackingSlipWorkflows, getPackingSlipWorkflowsLoading,
  getVendorWorkflows, getVendorWorkflowsLoading, getStockAdjustmentWorkflowsLoading,
  user, workflowType, getStockAdjustmentWorkflows, getStockTransferWorkflows, getStockTransferWorkflowsLoading, getGoodsReceivingWorkflows, getGoodsReceivingWorkflowsLoading, getSalesEstimateWorkflows, getSalesEstimateWorkflowsLoading,
  MONEY, departments, createWorkflowV2, createWorkflowV2Loading, getAPInvoiceWorkflows, getAPInvoiceWorkflowsLoading, getAnnualMaintenanceContractWorkflows, getDeliveryChallanWorkflows, getDeliveryChallanWorkflowsLoading,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [workflows, setWorkFlows] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [data, setData] = useState([]);
  const [enableUpdate, setEnableUpdate] = useState(false);
  const [call, setCall] = useState(false);

  const convertDataToNewData = (oldData) => {
    const newData = {
      template_workflow_steps: [],
    };
    oldData?.template_workflow_steps?.forEach((step, index) => {
      const newStep = {
        index,
        template_workflow_id: oldData?.template_workflow_id,
        template_workflow_step_id: step?.template_workflow_step_id,
        start_amt: step?.start_amt,
        end_amt: step?.end_amt,
        in_seq: step?.in_seq,
        tenant_department_id: oldData?.tenant_department_id,
        workflow_type: oldData?.workflow_type,
        steps: [],
      };
      const stepKeys = Object.keys(step).filter((key) => key.startsWith('step_'));
      stepKeys.forEach((stepKey, index) => {
        const stepData = step[stepKey];
        const stepNumber = index + 1;
        newStep?.steps.push({
          step_number: stepNumber,
          role_id: stepData?.role_id,
          role_name: stepData?.role_name,
          role_department_name: stepData?.role_department_name,
          template_workflow_step_id: step?.template_workflow_step_id,
        });
      });
      newData.template_workflow_steps.push(newStep);
    });
    return newData;
  };

  const getWorkflowCallback = (workflow) => {
    setWorkFlows(workflow);
    const departmentWorkflow = workflow?.find((item) => item?.tenant_department_id?.toString() === selectedDepartment?.toString());
    const newData = convertDataToNewData(departmentWorkflow);
    const templateWorkFlowSteps = newData?.template_workflow_steps?.map((item) => {
      const parentKey = uuidv4();
      const temp = {
        key: parentKey,
        ...item,
        steps: item?.steps?.filter((step) => step?.role_name)?.map((step) => ({ ...step, key: uuidv4(), parentKey })),
      };
      return temp;
    });
    setData(newData?.template_workflow_steps?.length > 0 ? templateWorkFlowSteps : []);
  };

  useEffect(() => {
    if (workflowType === 'PURCHASE_REQUISITION') getPurchaseRequestWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'PURCHASE_INDENT') {
      const query = {
        workflow_type: workflowType,
        tenant_id: user?.tenant_info?.tenant_id,
      };
      getPurchaseIndentWorkflows({ query }, (workflow) => {
        getWorkflowCallback(workflow?.data);
      });
    }
    if (workflowType === 'PURCHASE_ORDER') getPurchaseWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'VENDOR_PAYOUT') getVendorWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'SALES_ESTIMATE') getSalesEstimateWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'SALES_ORDER') getSalesOrderWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'PACKING_SLIP') getPackingSlipWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'INVOICE') getInvoiceWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'STOCK_ADJUSTMENT') getStockAdjustmentWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'STOCK_TRANSFER') getStockTransferWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'GOOD_RECEIVING_NOTE') getGoodsReceivingWorkflows((workflow) => getWorkflowCallback(workflow));
    if (workflowType === 'ACCOUNT_PAYABLE_INVOICE') {
      const query = {
        workflow_type: workflowType,
        tenant_id: user?.tenant_info?.tenant_id,
      };
      getAPInvoiceWorkflows({ query }, (workflow) => {
        getWorkflowCallback(workflow?.data);
      });
    }
    if (workflowType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      const query = {
        workflow_type: workflowType,
        tenant_id: user?.tenant_info?.tenant_id,
      };
      getAnnualMaintenanceContractWorkflows({ query }, (workflow) => {
        getWorkflowCallback(workflow?.data);
      });
    }
    if (workflowType === 'DELIVERY_CHALLAN') getDeliveryChallanWorkflows((workflow) => getWorkflowCallback(workflow));
  }, [call, selectedDepartment]);

  useEffect(() => {
    setSelectedDepartment(onlyStore ? user?.tenant_info?.default_store_id?.toString() : departments?.data?.result?.departments[0]?.tenant_department_id?.toString());
  }, [departments]);

  useEffect(() => {
    const departmentWorkflow = workflows?.find((item) => item?.tenant_department_id?.toString() === selectedDepartment?.toString());
    const newData = convertDataToNewData(departmentWorkflow);
    const templateWorkFlowSteps = newData?.template_workflow_steps?.map((item) => {
      const parentKey = uuidv4();
      const temp = {
        key: parentKey,
        ...item,
        steps: item?.steps?.filter((step) => step?.role_name)?.map((step) => ({ ...step, key: uuidv4(), parentKey })),
      };
      return temp;
    });
    setData(newData?.template_workflow_steps?.length > 0 ? templateWorkFlowSteps : []);
  }, [selectedDepartment]);

  useEffect(() => {
    if (!roles) {
      getRoles(user?.tenant_info?.tenant_id);
    }
  }, [user]);

  const addNewStep = (parentKey, templateWorkflowStepId, role, stepNumber) => {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i]?.key === parentKey) {
        if (copyData[i]?.steps && copyData[i].steps?.length > 0) {
          if (!stepNumber) {
            if (copyData[i].steps?.length < 10) {
              copyData[i].steps.push({
                parentKey,
                key: uuidv4(),
                template_workflow_step_id: templateWorkflowStepId,
                step_number: copyData[i].steps?.length + 1,
                role_id: role?.tenant_role_id,
                role_name: role?.tenant_role_name,
              });
            } else {
              notification.error({
                message: 'In accordance with our established protocol, the maximum allowable number of workflow steps is limited to ten.',
                placement: 'top',
                duration: 4,
              });
            }
          } else {
            for (let j = 0; j < copyData[i]?.steps?.length; j++) {
              if (copyData[i]?.steps[j]?.step_number === stepNumber) {
                copyData[i].steps[j] = {
                  ...copyData[i]?.steps[j],
                  role_id: role?.tenant_role_id,
                  role_name: role?.tenant_role_name,
                };
              }
            }
          }
        } else {
          copyData[i].steps = [{
            parentKey,
            key: uuidv4(),
            template_workflow_step_id: templateWorkflowStepId,
            step_number: 1,
            role_id: role?.tenant_role_id,
            role_name: role?.tenant_role_name,
          }];
        }
      }
    }
    setData(copyData);
    setEnableUpdate(true);
  };

  /**
   *
   */
  const updateWorkflow = () => {
    let hasError = false;
    setFormSubmitted(true);
    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.start_amt > data[i]?.end_amt) {
        hasError = true;
        break;
      }
    }
    if (!hasError) {
      const payload = data?.map((item) => {
        const _payload = {
          start_amt: item?.start_amt,
          end_amt: item?.end_amt,
          step_1: null,
          step_2: null,
          step_3: null,
          step_4: null,
          step_5: null,
          step_6: null,
          step_7: null,
          step_8: null,
          step_9: null,
          step_10: null,
        };
        const steps = item?.steps;
        for (let i = 0; i < steps?.length; i++) {
          _payload[`step_${steps[i]?.step_number}`] = steps[i]?.role_id;
        }
        return _payload;
      });
      createWorkflowV2({
        tenant_id: user?.tenant_info?.tenant_id,
        workflow_type: workflowType,
        tenant_department_id: selectedDepartment,
        template_workflow_steps: payload,
      }, () => {
        setEnableUpdate(false);
        setFormSubmitted(false);
        setCall(!call);
      });
    } else {
      notification.open({
        type: 'error',
        message: 'Start amount should be lower than the end amount for every workflow.',
        duration: 4,
        placement: 'top',
      });
    }
  };

  /**
   *
   * @param parentKey
   */
  const removeRange = (parentKey) => {
    const payload = data?.filter((item) => item?.key !== parentKey)?.map((item) => {
      const _payload = {
        start_amt: item?.start_amt,
        end_amt: item?.end_amt,
        step_1: null,
        step_2: null,
        step_3: null,
        step_4: null,
        step_5: null,
        step_6: null,
        step_7: null,
        step_8: null,
        step_9: null,
        step_10: null,
      };
      const steps = item?.steps;
      for (let i = 0; i < steps?.length; i++) {
        _payload[`step_${steps[i]?.step_number}`] = steps[i]?.role_id;
      }
      return _payload;
    });
    createWorkflowV2({
      tenant_id: user?.tenant_info?.tenant_id,
      workflow_type: workflowType,
      tenant_department_id: selectedDepartment,
      template_workflow_steps: payload,
    }, () => {
      setEnableUpdate(false);
      setFormSubmitted(false);
      setCall(!call);
    });
  };

  const removeStep = (parentKey, stepNumber) => {
    const copyData = JSON.parse(JSON.stringify(data));
    const payload = copyData?.map((item) => {
      const _payload = {
        start_amt: item?.start_amt,
        end_amt: item?.end_amt,
        step_1: null,
        step_2: null,
        step_3: null,
        step_4: null,
        step_5: null,
        step_6: null,
        step_7: null,
        step_8: null,
        step_9: null,
        step_10: null,
      };
      const steps = item?.steps;
      for (let i = 1; i <= 10; i++) {
        if (parentKey === item?.key) {
          if (i < stepNumber) {
            _payload[`step_${steps[i - 1]?.step_number}`] = steps[i - 1]?.role_id;
          } else {
            _payload[`step_${steps[i - 1]?.step_number}`] = steps[i]?.role_id || null;
          }
        } else {
          _payload[`step_${steps[i - 1]?.step_number}`] = steps[i - 1]?.role_id;
        }
      }
      return _payload;
    });
    createWorkflowV2({
      tenant_id: user?.tenant_info?.tenant_id,
      workflow_type: workflowType,
      tenant_department_id: selectedDepartment,
      template_workflow_steps: payload,
    }, () => setCall(!call));
  };

  const columns = [
    {
      title: 'Start Amount',
      width: '120px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div className="workflow_input-container">
          <H3Text text={MONEY(0).substring(0, 1)} className="" />
          <H3FormInput
            value={record?.start_amt}
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName={`orgFormInput ${(formSubmitted && (!record?.start_amt?.toString() || (Number(record?.start_amt) > Number(record?.end_amt)))) ? 'workflow-lines__input-error' : ''}`}
            onChange={(event) => {
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].start_amt = event.target.value;
                  if (copyData[i - 1]) copyData[i - 1].end_amt = Number(event.target.value) - 1;
                  break;
                }
              }
              setData(copyData);
              setEnableUpdate(true);
            }}
            disabled={!Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user)}
          />
        </div>
      ),
      fixed: 'left',
      hidden: (workflowType === 'STOCK_ADJUSTMENT' || workflowType === 'STOCK_TRANSFER' || workflowType === 'PURCHASE_INDENT' || workflowType === 'ACCOUNT_PAYABLE_INVOICE'),
    },
    {
      title: 'End Amount',
      width: '120px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div className="workflow_input-container">
          <H3Text text={MONEY(0).substring(0, 1)} className="" />
          <H3FormInput
            value={record?.end_amt}
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName={`orgFormInput ${(formSubmitted && (!record?.start_amt?.toString() || (Number(record?.start_amt) > Number(record?.end_amt)))) ? 'workflow-lines__input-error' : ''}`}
            onChange={(event) => {
              const copyData = JSON.parse(JSON.stringify(data));
              for (let i = 0; i < copyData?.length; i++) {
                if (copyData[i]?.key === record?.key) {
                  copyData[i].end_amt = event.target.value;
                  if (copyData[i + 1]) copyData[i + 1].start_amt = Number(event.target.value) + 1;
                  break;
                }
              }
              setData(copyData);
              setEnableUpdate(true);
            }}
            disabled={!Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user)}
          />
        </div>
      ),
      fixed: 'left',
      hidden: (workflowType === 'STOCK_ADJUSTMENT' || workflowType === 'STOCK_TRANSFER' || workflowType === 'PURCHASE_INDENT' ||  workflowType === 'ACCOUNT_PAYABLE_INVOICE'),
    },
    {
      title: 'Work Flow',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {record?.steps && record?.steps?.map((item) => (
            item?.step_number && (
              <SelectRole
                removeStep={(parentKey, stepNumber) => removeStep(parentKey, stepNumber)}
                parentKey={record?.key}
                stepNumber={item?.step_number}
                selectedRole={item?.role_id}
                excludedRoles={[]}
                tenantId={user?.tenant_info?.tenant_id}
                hideTitle
                onChange={(role) => {
                  addNewStep(record?.key, record?.template_workflow_step_id, role, item?.step_number);
                }}
                disabled={!Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user)}
                innerComponent={(
                  <div key={item?.step_number} className="workflow__step-wrapper">
                    <div className="workflow__step">
                      <div className="workflow__step-info">
                        <div className="workflow__step-count">
                          <H3Text text={item?.step_number} className="workflow__step-count-text" />
                        </div>
                      </div>
                      <H3Text text="" className="workflow__step-line" />
                    </div>
                    {item?.role_name ? (<div>{item?.role_name?.length > 11 ? `${item?.role_name.substring(0, 11)}..` : item?.role_name}</div>) : (
                      <div style={{ height: '16px' }}>{' '}</div>
                    )}
                  </div>
                )}
              />
            )
          ))}
          {record?.steps && record?.steps?.length < 10 ? (
            <div className="workflow__step-add-wrapper">
              <SelectRole
                excludedRoles={[]}
                tenantId={user?.tenant_info?.tenant_id}
                hideTitle
                onChange={(role) => {
                  addNewStep(record?.key, record?.template_workflow_step_id, role);
                }}
                innerComponent={(
                  <div className="workflow__step-info-add">
                    <div className="workflow__step-add">
                      <div className="workflow__step-count-add-text">
                        +
                      </div>
                    </div>
                  </div>
                )}
                disabled={!Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user)}
              />

              <div style={{ height: '16px' }}>{' '}</div>
            </div>
          ) : (
            <div className="workflow__step-add-wrapper">
              <SelectRole
                excludedRoles={[]}
                tenantId={user?.tenant_info?.tenant_id}
                hideTitle
                onChange={(role) => {
                  addNewStep(record?.key, record?.template_workflow_step_id, role);
                }}
                innerComponent={(
                  <div className="workflow__step-info-add">
                    <div className="workflow__step-add">
                      <div className="workflow__step-count-add-text">
                        +
                      </div>
                    </div>
                  </div>
                )}
                disabled={!Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user)}
              />
              <div style={{ height: '16px' }}>{' '}</div>
            </div>
          )}
        </div>
      ),
    },
    {
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '40px',
      fixed: 'right',
      render: (record) => (
        <Popconfirm
          disabled={record?.index !== data?.length - 1}
          title="Are you sure you want to remove this approval process?"
          onConfirm={() => removeRange(record?.key)}
          showCancel={false}
          okText="Confirm"
          placement='topRight'
        >
          <div className="delete-line-button" style={{ backgroundColor: (record?.index !== data?.length - 1) ? '#bbbbbb' : 'red' }}>
            <CloseOutlined />
          </div>
        </Popconfirm>
      ),
      className: !Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user) ? 'display-none' : '',
    },
  ].filter((item) => item.hidden !== true);

  /**
   *
   * @returns {*[]}
   */
  const getMenuItems = () => {
    const menuDepartments = [];
    for (let i = 0; i < departments?.data?.result?.departments?.length; i++) {
      const dept = departments?.data?.result?.departments[i];
      menuDepartments.push({
        key: dept?.tenant_department_id?.toString(),
        icon: null,
        children: null,
        label: <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <H3Text text={dept?.alias_name} className="workflow-menu-items__dept-name" />
            &nbsp;
            {dept?.tenant_department_id == user?.tenant_info?.default_store_id && <span className="status-tag" style={{ height: '15px', lineHeight: '15px', padding: '0px 3px' }}>Default</span>}
          </span>
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: workflows?.find((item) => item?.tenant_department_id === dept?.tenant_department_id) ? '#4ab72b' : '#c7c7c7', marginLeft: 'auto' }} />
        </div>,
        type: null,
        disabled: onlyStore && dept?.tenant_department_id != user?.tenant_info?.default_store_id,
      });
    }
    return menuDepartments;
  };

  const dataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    return copyData;
  };

  return (
    <Fragment>
      <div className="ant-row">
        {!selectedDepartment ? (
          <div className="workflow-menu-items__loader">
            <Spin />
          </div>
        ) : (
          <div className="ant-col-md-24">
            <div className="workflow-menu-items__wrapper doc-list__wrapper doc-list__tab-content">
              <Menu
                onClick={(event) => {
                  setSelectedDepartment(event.key?.toString());
                }}
                style={{
                  width: 256,
                }}
                selectedKeys={[selectedDepartment?.toString()]}
                defaultSelectedKeys={[selectedDepartment?.toString()]}
                mode="inline"
                items={getMenuItems()}
              />
              <div className="workflow-menu-items">
                <div className="workflow__table-container doc-list__table-wrapper">
                  <Table
                    loading={getPurchaseRequestWorkflowsLoading || getPurchaseIndentWorkflowsLoading || getInvoiceWorkflowsLoading || getPurchaseWorkflowsLoading || getSalesOrderWorkflowsLoading || getVendorWorkflowsLoading || getStockAdjustmentWorkflowsLoading || getStockTransferWorkflowsLoading || getGoodsReceivingWorkflowsLoading || getAPInvoiceWorkflowsLoading || getSalesEstimateWorkflowsLoading || getPackingSlipWorkflowsLoading || getDeliveryChallanWorkflowsLoading}
                    showHeader
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={dataSource() || []}
                    pagination={false}
                    bordered
                  />
                </div>
                {Helpers.getPermission(Helpers.permissionEntities.WORKFLOW_SETUP, Helpers.permissionTypes.CREATE, user) && (
                  <div className="flex-display" style={{ marginLeft: '10px' }}>
                    {((workflowType === 'STOCK_TRANSFER' || workflowType === 'STOCK_ADJUSTMENT' || workflowType === 'PURCHASE_INDENT' || workflowType === 'ACCOUNT_PAYABLE_INVOICE') ? data.length < 1 : true) && (
                      <div
                        className="new-row-button"
                        onClick={() => {
                          const newRange = {
                            key: uuidv4(),
                            start_amt: data?.length ? Number(data[data?.length - 1]?.end_amt) + 1 : 1,
                            end_amt: data?.length ? ((Number(data[data?.length - 1]?.end_amt) * 2) + 1) : 99999,
                            workflow_type: workflowType,
                            steps: data[data?.length - 1]?.steps || [],
                            index: data?.length,
                          };
                          setData([...data, newRange]);
                          setEnableUpdate(true);
                        }}
                        style={{ marginRight: '10px', height: '32px' }}
                      >
                        <span className="new-row-button__icon"><PlusCircleFilled /></span>
                        <div>New Range</div>
                      </div>
                    )}
                    <Button
                      loading={createWorkflowV2Loading}
                      style={{ marginTop: '10px' }}
                      type="primary"
                      onClick={() => updateWorkflow()}
                      disabled={!enableUpdate || createWorkflowV2Loading}
                    >
                      <SaveOutlined />
                      &nbsp;Save
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, WorkflowsReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  getPurchaseRequestWorkflowsLoading: WorkflowsReducers.getPurchaseRequestWorkflowsLoading,
  getPurchaseIndentWorkflowsLoading: GetPurchaseIndentWorkflows.loading,
  getAPInvoiceWorkflowsLoading: GetAPInvoiceWorkflows.loading,
  getPurchaseWorkflowsLoading: WorkflowsReducers.getPurchaseWorkflowsLoading,
  getInvoiceWorkflowsLoading: WorkflowsReducers.getInvoiceWorkflowsLoading,
  getStockAdjustmentWorkflowsLoading: WorkflowsReducers.getStockAdjustmentWorkflowsLoading,
  getSalesEstimateWorkflowsLoading: WorkflowsReducers.getSalesEstimateWorkflowsLoading,
  getSalesOrderWorkflowsLoading: WorkflowsReducers.getSalesOrderWorkflowsLoading,
  getPackingSlipWorkflowsLoading: WorkflowsReducers.getPackingSlipWorkflowsLoading,
  getVendorWorkflowsLoading: WorkflowsReducers.getVendorWorkflowsLoading,
  getStockTransferWorkflowsLoading: WorkflowsReducers.getStockTransferWorkflowsLoading,
  getGoodsReceivingWorkflowsLoading: WorkflowsReducers.getGoodsReceivingWorkflowsLoading,
  getDeliveryChallanWorkflowsLoading: WorkflowsReducers.getDeliveryChallanWorkflowsLoading,
  createWorkflowV2Loading: WorkflowsReducers.createWorkflowV2Loading,
  MONEY: UserReducers.MONEY,
  departments: DepartmentReducers.departments,
});

const mapDispatchToProps = (dispatch) => ({
  getRoles: (tenantId, tenantDepartmentId) => dispatch(UserActions.getRoles(tenantId, tenantDepartmentId)),
  getPurchaseRequestWorkflows: (callback) => dispatch(WorkflowActions.getPurchaseRequestWorkflows(callback)),
  getInvoiceWorkflows: (callback) => dispatch(WorkflowActions.getInvoiceWorkflows(callback)),
  getStockAdjustmentWorkflows: (callback) => dispatch(WorkflowActions.getStockAdjustmentWorkflows(callback)),
  getStockTransferWorkflows: (callback) => dispatch(WorkflowActions.getStockTransferWorkflows(callback)),
  getGoodsReceivingWorkflows: (callback) => dispatch(WorkflowActions.getGoodsReceivingWorkflows(callback)),
  getAnnualMaintenanceContractWorkflows: (payload, callback) => dispatch(GetAnnualMaintenanceContractWorkflows.actions.request(payload, callback)),
  getPurchaseIndentWorkflows: (payload, callback) => dispatch(GetPurchaseIndentWorkflows.actions.request(payload, callback)),
  getAPInvoiceWorkflows: (payload, callback) => dispatch(GetAPInvoiceWorkflows.actions.request(payload, callback)),
  getPurchaseWorkflows: (callback) => dispatch(WorkflowActions.getPurchaseWorkflows(callback)),
  getSalesEstimateWorkflows: (callback) => dispatch(WorkflowActions.getSalesEstimateWorkflows(callback)),
  getSalesOrderWorkflows: (callback) => dispatch(WorkflowActions.getSalesOrderWorkflows(callback)),
  getPackingSlipWorkflows: (callback) => dispatch(WorkflowActions.getPackingSlipWorkflows(callback)),
  getVendorWorkflows: (callback) => dispatch(WorkflowActions.getVendorWorkflows(callback)),
  createWorkflowV2: (payload, callback) => dispatch(WorkflowActions.createWorkflowV2(payload, callback)),
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback)),
  getDeliveryChallanWorkflows: (callback) => dispatch(WorkflowActions.getDeliveryChallanWorkflows(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkflowList));
